module.exports = __webpack_public_path__ + "db7c1d4070cd22cdb76e69ac3e5cdec4.MP3";